function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import getByPath from 'lodash/get';
import translate from '../../../../lib/utils/translate';

export default (function (intl, category, type) {
  var _banksBR;

  var items = {
    accountTypes: {
      C: function C() {
        return translate({
          id: 'cashier.details.accountTypes.C',
          defaultMessage: 'Current account'
        }, intl);
      },
      S: function S() {
        return translate({
          id: 'cashier.details.accountTypes.S',
          defaultMessage: 'Savings account'
        }, intl);
      },
      I: function I() {
        return translate({
          id: 'cashier.details.accountTypes.I',
          defaultMessage: 'International account'
        }, intl);
      },
      M: function M() {
        return translate({
          id: 'cashier.details.accountTypes.M',
          defaultMessage: 'Master account'
        }, intl);
      },
      V: function V() {
        return translate({
          id: 'cashier.details.accountTypes.V',
          defaultMessage: 'Salary account'
        }, intl);
      }
    },
    services: {
      BF: function BF() {
        return translate({
          id: 'cashier.details.services.BF',
          defaultMessage: 'BBVA Frances'
        }, intl);
      },
      MA: function MA() {
        return translate({
          id: 'cashier.details.services.MA',
          defaultMessage: 'Macro'
        }, intl);
      },
      PF: function PF() {
        return translate({
          id: 'cashier.details.services.PF',
          defaultMessage: 'Pago Facil'
        }, intl);
      },
      SI: function SI() {
        return translate({
          id: 'cashier.details.services.SI',
          defaultMessage: 'Santander Rio'
        }, intl);
      },
      B: function B() {
        return translate({
          id: 'cashier.details.services.B',
          defaultMessage: 'Bradesco'
        }, intl);
      },
      BB: function BB() {
        return translate({
          id: 'cashier.details.services.BB',
          defaultMessage: 'Banco do Brasil'
        }, intl);
      },
      CA: function CA() {
        return translate({
          id: 'cashier.details.services.CA',
          defaultMessage: 'Caixa'
        }, intl);
      },
      I: function I() {
        return translate({
          id: 'cashier.details.services.I',
          defaultMessage: 'Itau'
        }, intl);
      },
      SB: function SB() {
        return translate({
          id: 'cashier.details.services.SB',
          defaultMessage: 'Santander'
        }, intl);
      },
      BZ: function BZ() {
        return translate({
          id: 'cashier.details.services.BZ',
          defaultMessage: 'Banco Original'
        }, intl);
      },
      SF: function SF() {
        return translate({
          id: 'cashier.details.services.SF',
          defaultMessage: 'Banco Safra'
        }, intl);
      },
      UL: function UL() {
        return translate({
          id: 'cashier.details.services.UL',
          defaultMessage: 'Banrisul'
        }, intl);
      },
      LC: function LC() {
        return translate({
          id: 'cashier.details.services.LC',
          defaultMessage: 'Loterias Caixa'
        }, intl);
      },
      BE: function BE() {
        return translate({
          id: 'cashier.details.services.BE',
          defaultMessage: 'Banco Estado'
        }, intl);
      },
      BX: function BX() {
        return translate({
          id: 'cashier.details.services.BX',
          defaultMessage: 'Banco de Chile'
        }, intl);
      },
      CE: function CE() {
        return translate({
          id: 'cashier.details.services.CE',
          defaultMessage: 'Banco BICE'
        }, intl);
      },
      CI: function CI() {
        return translate({
          id: 'cashier.details.services.CI',
          defaultMessage: 'Banco BCI'
        }, intl);
      },
      LE: function LE() {
        return translate({
          id: 'cashier.details.services.LE',
          defaultMessage: 'Credichile'
        }, intl);
      },
      LL: function LL() {
        return translate({
          id: 'cashier.details.services.LL',
          defaultMessage: 'Falabella'
        }, intl);
      },
      TY: function TY() {
        return translate({
          id: 'cashier.details.services.TY',
          defaultMessage: 'Security'
        }, intl);
      },
      IA: function IA() {
        return translate({
          id: 'cashier.details.services.IA',
          defaultMessage: 'Itau'
        }, intl);
      },
      SC: function SC() {
        return translate({
          id: 'cashier.details.services.SC',
          defaultMessage: 'Santander'
        }, intl);
      },
      WP: function WP() {
        return translate({
          id: 'cashier.details.services.WP',
          defaultMessage: 'WebPay'
        }, intl);
      },
      BU: function BU() {
        return translate({
          id: 'cashier.details.services.BU',
          defaultMessage: 'Baloto'
        }, intl);
      },
      EY: function EY() {
        return translate({
          id: 'cashier.details.services.EY',
          defaultMessage: 'Efecty'
        }, intl);
      },
      RV: function RV() {
        return translate({
          id: 'cashier.details.services.RV',
          defaultMessage: 'Redservi'
        }, intl);
      },
      PD: function PD() {
        return translate({
          id: 'cashier.details.services.PD',
          defaultMessage: 'Punto Red'
        }, intl);
      },
      AV: function AV() {
        return translate({
          id: 'cashier.details.services.AV',
          defaultMessage: 'BBVA'
        }, intl);
      },
      BN: function BN() {
        return translate({
          id: 'cashier.details.services.BN',
          defaultMessage: 'Bancolombia'
        }, intl);
      },
      PC: function PC() {
        return translate({
          id: 'cashier.details.services.PC',
          defaultMessage: 'PSE'
        }, intl);
      },
      EX: function EX() {
        return translate({
          id: 'cashier.details.services.EX',
          defaultMessage: 'Almacenes Exito'
        }, intl);
      },
      CR: function CR() {
        return translate({
          id: 'cashier.details.services.CR',
          defaultMessage: 'Carulla'
        }, intl);
      },
      SX: function SX() {
        return translate({
          id: 'cashier.details.services.SX',
          defaultMessage: 'Surtimax'
        }, intl);
      },
      RD: function RD() {
        return translate({
          id: 'cashier.details.services.RD',
          defaultMessage: 'Su Red'
        }, intl);
      },
      OS: function OS() {
        return translate({
          id: 'cashier.details.services.OS',
          defaultMessage: 'Acertemos'
        }, intl);
      },
      TA: function TA() {
        return translate({
          id: 'cashier.details.services.TA',
          defaultMessage: 'Cucuta 75'
        }, intl);
      },
      UA: function UA() {
        return translate({
          id: 'cashier.details.services.UA',
          defaultMessage: 'Apuestas Unidas'
        }, intl);
      },
      GG: function GG() {
        return translate({
          id: 'cashier.details.services.GG',
          defaultMessage: 'Gana Gana'
        }, intl);
      },
      GC: function GC() {
        return translate({
          id: 'cashier.details.services.GC',
          defaultMessage: 'Gana cerca de ti'
        }, intl);
      },
      JE: function JE() {
        return translate({
          id: 'cashier.details.services.JE',
          defaultMessage: 'JER'
        }, intl);
      },
      LP: function LP() {
        return translate({
          id: 'cashier.details.services.LP',
          defaultMessage: 'La perla'
        }, intl);
      },
      TP: function TP() {
        return translate({
          id: 'cashier.details.services.TP',
          defaultMessage: 'Paga Todo'
        }, intl);
      },
      CX: function CX() {
        return translate({
          id: 'cashier.details.services.CX',
          defaultMessage: 'Su Chance'
        }, intl);
      },
      VI: function VI() {
        return translate({
          id: 'cashier.details.services.VI',
          defaultMessage: 'VISA'
        }, intl);
      },
      MC: function MC() {
        return translate({
          id: 'cashier.details.services.MC',
          defaultMessage: 'Master Card'
        }, intl);
      },
      DC: function DC() {
        return translate({
          id: 'cashier.details.services.DC',
          defaultMessage: 'Dinners'
        }, intl);
      },
      AE: function AE() {
        return translate({
          id: 'cashier.details.services.AE',
          defaultMessage: 'American Express'
        }, intl);
      },
      WL: function WL() {
        return translate({
          id: 'cashier.details.services.WL',
          defaultMessage: 'eWallets'
        }, intl);
      },
      NB: function NB() {
        return translate({
          id: 'cashier.details.services.NB',
          defaultMessage: 'Netbanking'
        }, intl);
      },
      UI: function UI() {
        return translate({
          id: 'cashier.details.services.UI',
          defaultMessage: 'UPI'
        }, intl);
      },
      OX: function OX() {
        return translate({
          id: 'cashier.details.services.OX',
          defaultMessage: 'OXXO'
        }, intl);
      },
      BV: function BV() {
        return translate({
          id: 'cashier.details.services.BV',
          defaultMessage: 'BBVA Bancomer'
        }, intl);
      },
      BM: function BM() {
        return translate({
          id: 'cashier.details.services.BM',
          defaultMessage: 'Banamex'
        }, intl);
      },
      BQ: function BQ() {
        return translate({
          id: 'cashier.details.services.BQ',
          defaultMessage: 'Banorte'
        }, intl);
      },
      SM: function SM() {
        return translate({
          id: 'cashier.details.services.SM',
          defaultMessage: 'Santander'
        }, intl);
      },
      SE: function SE() {
        return translate({
          id: 'cashier.details.services.SE',
          defaultMessage: 'Spei'
        }, intl);
      },
      TC: function TC() {
        return translate({
          id: 'cashier.details.services.TC',
          defaultMessage: 'Todito Cash'
        }, intl);
      },
      AZ: function AZ() {
        return translate({
          id: 'cashier.details.services.AZ',
          defaultMessage: 'Banco Azteca'
        }, intl);
      },
      PN: function PN() {
        return translate({
          id: 'cashier.details.services.PN',
          defaultMessage: 'PayNet'
        }, intl);
      },
      BW: function BW() {
        return translate({
          id: 'cashier.details.services.BW',
          defaultMessage: 'Bodega Aurera'
        }, intl);
      },
      CU: function CU() {
        return translate({
          id: 'cashier.details.services.CU',
          defaultMessage: 'Circulo K'
        }, intl);
      },
      EN: function EN() {
        return translate({
          id: 'cashier.details.services.EN',
          defaultMessage: '7 Eleven'
        }, intl);
      },
      FA: function FA() {
        return translate({
          id: 'cashier.details.services.FA',
          defaultMessage: 'Farmacias del ahorro'
        }, intl);
      },
      FB: function FB() {
        return translate({
          id: 'cashier.details.services.FB',
          defaultMessage: 'Farmacias Benavides'
        }, intl);
      },
      SS: function SS() {
        return translate({
          id: 'cashier.details.services.SS',
          defaultMessage: 'Sams club'
        }, intl);
      },
      SU: function SU() {
        return translate({
          id: 'cashier.details.services.SU',
          defaultMessage: 'Superama'
        }, intl);
      },
      WA: function WA() {
        return translate({
          id: 'cashier.details.services.WA',
          defaultMessage: 'Walmart'
        }, intl);
      },
      VD: function VD() {
        return translate({
          id: 'cashier.details.services.VD',
          defaultMessage: 'VISA Debit'
        }, intl);
      },
      MD: function MD() {
        return translate({
          id: 'cashier.details.services.MD',
          defaultMessage: 'Master Card Debit'
        }, intl);
      },
      DI: function DI() {
        return translate({
          id: 'cashier.details.services.DI',
          defaultMessage: 'Credicorp'
        }, intl);
      },
      PE: function PE() {
        return translate({
          id: 'cashier.details.services.PE',
          defaultMessage: 'Pago Express'
        }, intl);
      },
      EF: function EF() {
        return translate({
          id: 'cashier.details.services.EF',
          defaultMessage: 'PagoEfectivo'
        }, intl);
      },
      IB: function IB() {
        return translate({
          id: 'cashier.details.services.IB',
          defaultMessage: 'Interbank'
        }, intl);
      },
      BC: function BC() {
        return translate({
          id: 'cashier.details.services.BC',
          defaultMessage: 'BCP'
        }, intl);
      },
      ST: function ST() {
        return translate({
          id: 'cashier.details.services.ST',
          defaultMessage: 'Scotia'
        }, intl);
      },
      WU: function WU() {
        return translate({
          id: 'cashier.details.services.WU',
          defaultMessage: 'Western Union'
        }, intl);
      },
      BP: function BP() {
        return translate({
          id: 'cashier.details.services.BP',
          defaultMessage: 'BBVA Peru'
        }, intl);
      },
      HC: function HC() {
        return translate({
          id: 'cashier.details.services.HC',
          defaultMessage: 'Caja Huancayo'
        }, intl);
      },
      US: function US() {
        return translate({
          id: 'cashier.details.services.US',
          defaultMessage: 'Caja Cusco'
        }, intl);
      },
      JA: function JA() {
        return translate({
          id: 'cashier.details.services.JA',
          defaultMessage: 'Caja Arequipa'
        }, intl);
      },
      JI: function JI() {
        return translate({
          id: 'cashier.details.services.JI',
          defaultMessage: 'Caja ICA'
        }, intl);
      },
      JP: function JP() {
        return translate({
          id: 'cashier.details.services.JP',
          defaultMessage: 'Caja Piura'
        }, intl);
      },
      JR: function JR() {
        return translate({
          id: 'cashier.details.services.JR',
          defaultMessage: 'Caja Trujillo'
        }, intl);
      },
      JT: function JT() {
        return translate({
          id: 'cashier.details.services.JT',
          defaultMessage: 'Caja Tacna'
        }, intl);
      },
      RE: function RE() {
        return translate({
          id: 'cashier.details.services.RE',
          defaultMessage: 'Red Pagos'
        }, intl);
      },
      MP: function MP() {
        return translate({
          id: 'cashier.details.services.MP',
          defaultMessage: 'M-Pesa'
        }, intl);
      },
      PL: function PL() {
        return translate({
          id: 'cashier.details.services.PL',
          defaultMessage: 'PesaLink'
        }, intl);
      },
      UB: function UB() {
        return translate({
          id: 'cashier.details.services.UB',
          defaultMessage: 'UBA'
        }, intl);
      },
      AA: function AA() {
        return translate({
          id: 'cashier.details.services.AA',
          defaultMessage: 'Paga'
        }, intl);
      },
      AR: function AR() {
        return translate({
          id: 'cashier.details.services.AR',
          defaultMessage: 'Agricultural Bank of China'
        }, intl);
      },
      PO: function PO() {
        return translate({
          id: 'cashier.details.services.PO',
          defaultMessage: 'China Postal Savings Bank'
        }, intl);
      },
      BH: function BH() {
        return translate({
          id: 'cashier.details.services.BH',
          defaultMessage: 'Bank of China'
        }, intl);
      },
      BJ: function BJ() {
        return translate({
          id: 'cashier.details.services.BJ',
          defaultMessage: 'Bank of Beijing'
        }, intl);
      },
      BS: function BS() {
        return translate({
          id: 'cashier.details.services.BS',
          defaultMessage: 'Bank of Communications'
        }, intl);
      },
      CC: function CC() {
        return translate({
          id: 'cashier.details.services.CC',
          defaultMessage: 'China Construction Bank'
        }, intl);
      },
      CG: function CG() {
        return translate({
          id: 'cashier.details.services.CG',
          defaultMessage: 'China Guangfa Bank'
        }, intl);
      },
      CH: function CH() {
        return translate({
          id: 'cashier.details.services.CH',
          defaultMessage: 'China Merchants Bank'
        }, intl);
      },
      IC: function IC() {
        return translate({
          id: 'cashier.details.services.IC',
          defaultMessage: 'Industrial Bank'
        }, intl);
      },
      ID: function ID() {
        return translate({
          id: 'cashier.details.services.ID',
          defaultMessage: 'Industrial and Commercial Bank of China'
        }, intl);
      },
      MN: function MN() {
        return translate({
          id: 'cashier.details.services.MN',
          defaultMessage: 'China Minsheng Bank'
        }, intl);
      },
      SD: function SD() {
        return translate({
          id: 'cashier.details.services.SD',
          defaultMessage: 'Shangai Pudong Dev Bank'
        }, intl);
      },
      PI: function PI() {
        return translate({
          id: 'cashier.details.services.PI',
          defaultMessage: 'PingAn Bank'
        }, intl);
      },
      HX: function HX() {
        return translate({
          id: 'cashier.details.services.HX',
          defaultMessage: 'Huaxia Bank'
        }, intl);
      },
      CN: function CN() {
        return translate({
          id: 'cashier.details.services.CN',
          defaultMessage: 'China Citic Bank'
        }, intl);
      },
      EV: function EV() {
        return translate({
          id: 'cashier.details.services.EV',
          defaultMessage: 'China Everbright Bank'
        }, intl);
      },
      UP: function UP() {
        return translate({
          id: 'cashier.details.services.UP',
          defaultMessage: 'Unionpay'
        }, intl);
      }
    },
    idTypes: {
      CUIT: function CUIT() {
        return translate({
          id: 'cashier.details.idTypes.CUIT',
          defaultMessage: 'CUIT'
        }, intl);
      },
      CUIL: function CUIL() {
        return translate({
          id: 'cashier.details.idTypes.CUIL',
          defaultMessage: 'CUIL'
        }, intl);
      },
      CPF: function CPF() {
        return translate({
          id: 'cashier.details.idTypes.CPF',
          defaultMessage: 'CPF'
        }, intl);
      },
      CNPJ: function CNPJ() {
        return translate({
          id: 'cashier.details.idTypes.CNPJ',
          defaultMessage: 'CNPJ'
        }, intl);
      },
      RUT: function RUT() {
        return translate({
          id: 'cashier.details.idTypes.RUT',
          defaultMessage: 'RUT'
        }, intl);
      },
      CC: function CC() {
        return translate({
          id: 'cashier.details.idTypes.CC',
          defaultMessage: 'CC'
        }, intl);
      },
      NIT: function NIT() {
        return translate({
          id: 'cashier.details.idTypes.NIT',
          defaultMessage: 'NIT'
        }, intl);
      },
      ID: function ID() {
        return translate({
          id: 'cashier.details.idTypes.ID',
          defaultMessage: 'ID'
        }, intl);
      },
      CURP: function CURP() {
        return translate({
          id: 'cashier.details.idTypes.CURP',
          defaultMessage: 'CURP'
        }, intl);
      },
      RFC: function RFC() {
        return translate({
          id: 'cashier.details.idTypes.RFC',
          defaultMessage: 'RFC'
        }, intl);
      },
      IFE: function IFE() {
        return translate({
          id: 'cashier.details.idTypes.IFE',
          defaultMessage: 'IFE'
        }, intl);
      },
      CE: function CE() {
        return translate({
          id: 'cashier.details.idTypes.CE',
          defaultMessage: 'CE'
        }, intl);
      },
      DNI: function DNI() {
        return translate({
          id: 'cashier.details.idTypes.DNI',
          defaultMessage: 'DNI'
        }, intl);
      },
      PASS: function PASS() {
        return translate({
          id: 'cashier.details.idTypes.PASS',
          defaultMessage: 'PASS'
        }, intl);
      },
      RUC: function RUC() {
        return translate({
          id: 'cashier.details.idTypes.RUC',
          defaultMessage: 'RUC'
        }, intl);
      },
      CI: function CI() {
        return translate({
          id: 'cashier.details.idTypes.CI',
          defaultMessage: 'CI'
        }, intl);
      }
    },
    banksBR: (_banksBR = {
      '075': function _() {
        return 'BANCO ABN AMRO S.A.';
      },
      '085': function _() {
        return 'Cooperativa Central de Crédito Urbano-CECRED';
      },
      '003': function _() {
        return 'BANCO DA AMAZONIA S.A.';
      },
      '004': function _() {
        return 'BANCO DO NORDESTE DO BRASIL S.A.';
      },
      218: function _() {
        return 'BANCO BONSUCESSO S.A.';
      },
      237: function _() {
        return 'BANCO BRADESCO S.A.';
      },
      '001': function _() {
        return 'BANCO DO BRASIL S.A.';
      },
      '070': function _() {
        return 'BANCO DE BRASILIA S.A. - BRB';
      },
      104: function _() {
        return 'CAIXA ECONOMICA FEDERAL - CEF';
      },
      477: function _() {
        return 'CITIBANK N.A.';
      },
      756: function _() {
        return 'BANCO COOPERATIVO DO BRASIL S/A - BANCOOB';
      },
      707: function _() {
        return 'BANCO DAYCOVAL S.A.';
      },
      '021': function _() {
        return 'BANESTES S.A. BANCO DO ESTADO DO ESPIRITO SANTO';
      },
      '037': function _() {
        return 'BANCO DO ESTADO DO PARA S.A. - BANPARA';
      },
      '041': function _() {
        return 'BANCO DO ESTADO DO RIO GRANDE DO SUL S.A. - BANRISUL';
      },
      '047': function _() {
        return 'BANCO DO ESTADO DE SERGIPE S.A. - BANESE';
      },
      399: function _() {
        return 'HSBC BANK BRASIL S.A. - BANCO MULTIPLO';
      },
      341: function _() {
        return 'ITAU UNIBANCO S.A.';
      },
      389: function _() {
        return 'BANCO MERCANTIL DO BRASIL S.A.';
      },
      746: function _() {
        return 'BANCO MODAL S.A.';
      },
      422: function _() {
        return 'BANCO SAFRA S.A.';
      },
      '033': function _() {
        return 'BANCO SANTANDER BRASIL S.A.';
      },
      748: function _() {
        return 'BANCO COOPERATIVO SICREDI S.A.';
      },
      '077': function _() {
        return 'BANCO INTER';
      },
      637: function _() {
        return 'BANCO SOFISA';
      },
      735: function _() {
        return 'BANCO NEON';
      },
      260: function _() {
        return 'NU PAGAMENTOS';
      }
    }, _defineProperty(_banksBR, '085', function _() {
      return 'Cooperativa Central de Crédito Urbano-CECRED';
    }), _defineProperty(_banksBR, 121, function _() {
      return 'BANCO AGIPLAN S.A.';
    }), _defineProperty(_banksBR, 136, function _() {
      return 'Confederação Nacional das Cooperativas Centrais Unicred';
    }), _defineProperty(_banksBR, 212, function _() {
      return 'BANCO ORIGINAL';
    }), _defineProperty(_banksBR, 655, function _() {
      return 'Banco Votorantim S.A.';
    }), _defineProperty(_banksBR, 745, function _() {
      return 'BANCO CITIBANK';
    }), _defineProperty(_banksBR, 290, function _() {
      return 'PagSeguro Internet S.A.';
    }), _defineProperty(_banksBR, 318, function _() {
      return 'BANCO BMG S.A.';
    }), _defineProperty(_banksBR, 336, function _() {
      return 'BANCO C6 S.A.';
    }), _banksBR),
    banksCL: {
      '001': function _() {
        return 'Banco de Chile / Banco Edwards / Citi';
      },
      '009': function _() {
        return 'Banco Internacional';
      },
      '012': function _() {
        return 'Banco del Estado de Chile';
      },
      '014': function _() {
        return 'Scotiabank Sud Americano';
      },
      '016': function _() {
        return 'Banco Crédito e Inversiones';
      },
      '027': function _() {
        return 'Corpbanca';
      },
      '028': function _() {
        return 'Banco Bice';
      },
      '031': function _() {
        return 'HSBC Bank';
      },
      '037': function _() {
        return 'Banco Santander- Santiago';
      },
      '039': function _() {
        return 'Banco Itaú';
      },
      '046': function _() {
        return 'ABN Amor Bank Chile';
      },
      '049': function _() {
        return 'Banco Security';
      },
      '051': function _() {
        return 'Banco Falabella';
      },
      '052': function _() {
        return 'Deutsche Bank';
      },
      '053': function _() {
        return 'Banco Ripley';
      },
      '054': function _() {
        return 'Rabobank Chile';
      },
      '055': function _() {
        return 'Consorcio';
      },
      '056': function _() {
        return 'Banco Penta';
      },
      '057': function _() {
        return 'Banco Paris';
      },
      504: function _() {
        return 'BBVA Banco Bhif';
      },
      507: function _() {
        return 'Banco del Desarrollo';
      }
    },
    banksCO: {
      '001': function _() {
        return 'Banco de Bogota';
      },
      '002': function _() {
        return 'Banco Popular';
      },
      '003': function _() {
        return 'Banco CorpBanca';
      },
      '006': function _() {
        return 'Banco Santander';
      },
      '007': function _() {
        return 'Bancolombia S.A';
      },
      '009': function _() {
        return 'Citibank Colombia';
      },
      '010': function _() {
        return 'Banco HSBC';
      },
      '012': function _() {
        return 'Banco GNB Sudameris Colombia';
      },
      '013': function _() {
        return 'BBVA Colombia';
      },
      '014': function _() {
        return 'Helm Bank';
      },
      '019': function _() {
        return 'Red Multibanca Colpatria S.A';
      },
      '023': function _() {
        return 'Banco de Occidente';
      },
      '032': function _() {
        return 'Banco Caja Social BCSC S.A.';
      },
      '040': function _() {
        return 'Banco Agrario de Colombia S.A.';
      },
      '051': function _() {
        return 'Banco Davivienda S.A.';
      },
      '052': function _() {
        return 'Banco Av Villas';
      },
      '058': function _() {
        return 'Banco Procredit';
      },
      '060': function _() {
        return 'Banco Pichincha S.A.';
      },
      '061': function _() {
        return 'Bancoomeva';
      },
      '062': function _() {
        return 'Banco Falabella S.A.';
      },
      '076': function _() {
        return 'COOPCENTRAL S.A';
      },
      283: function _() {
        return 'COOPERATIVA FINANCIERA DE ANTIOQUIA';
      },
      289: function _() {
        return 'COTRAFA COOPERATIVA FINANCIERA';
      },
      292: function _() {
        return 'CONFIAR';
      },
      296: function _() {
        return 'FINANCIERA JURISCOOP';
      },
      1507: function _() {
        return 'Nequi';
      },
      1551: function _() {
        return 'Daviplata';
      }
    },
    banksPE: {
      '001': function _() {
        return 'Banco Central de Reserva';
      },
      '002': function _() {
        return 'Banco de Crédito del Perú';
      },
      '003': function _() {
        return 'Interbank';
      },
      '007': function _() {
        return 'Citibank';
      },
      '009': function _() {
        return 'Scotiabank';
      },
      '011': function _() {
        return 'BBVA Continental';
      },
      '018': function _() {
        return 'Banco de la Nación';
      },
      '023': function _() {
        return 'Banco de Comercio';
      },
      '035': function _() {
        return 'Banco Financiero';
      },
      '038': function _() {
        return 'Banco Interamericano de Finanzas (BIF)';
      },
      '043': function _() {
        return 'Crediscotia Financiera';
      },
      '049': function _() {
        return 'Mi Banco';
      },
      '053': function _() {
        return 'Banco GNB Perú S.A.';
      },
      '054': function _() {
        return 'Banco Falabella';
      },
      '056': function _() {
        return 'Santander';
      },
      800: function _() {
        return 'Caja Metropolitana de Lima';
      },
      801: function _() {
        return 'Caja Municipal de Ahorro y Crédito Plura SAC';
      },
      802: function _() {
        return 'Caja Municipal de Ahorro y Crédito Trujillo';
      },
      803: function _() {
        return 'Caja Municipal de Ahorro y Crédito Arequipa';
      },
      805: function _() {
        return 'Caja Municipal de Ahorro y Crédito Sullana';
      },
      806: function _() {
        return 'Caja Municipal de Ahorro y Crédito Cuzco';
      },
      808: function _() {
        return 'Caja Municipal de Ahorro y Crédito Huancayo';
      }
    }
  };

  return getByPath(items, '[' + category + '][' + type + ']', function () {
    return type;
  })();
});